import { IParamsCountersName } from '@media-platform/analytic-counters';
import { ABYSSINIAN_ENG, BENGAL_ENG, BRITISH_ENG, CANADIAN_SPHINX_ENG, MAINE_COON_ENG, PERSIAN_ENG, SIAMESE_ENG, NEVA_MASQUERADE_ENG, SCOTTISH_ENG, YORKSHIRE_TERRIER_ENG, CORGI_ENG, LABRADOR_RETRIEVER_ENG, PUG_ENG, GERMAN_SHEPHERD_ENG, GERMAN_SPITZ_ENG, SIBERIAN_HUSKY_ENG, DACHSHUND_ENG, FRENCH_BULLDOG_ENG, CHIHUAHUA_ENG, RUSSKIJ_TOJ_ENG, } from 'Tools/breedsWidget';
const breedCounters: {
    [key: string]: string;
} = {
    // кошки
    [ABYSSINIAN_ENG]: '99371785',
    [BENGAL_ENG]: '99371786',
    [BRITISH_ENG]: '99371789',
    [CANADIAN_SPHINX_ENG]: '99371790',
    [MAINE_COON_ENG]: '99371791',
    [PERSIAN_ENG]: '99371792',
    [SIAMESE_ENG]: '99371793',
    [NEVA_MASQUERADE_ENG]: '99371796',
    [SCOTTISH_ENG]: '99371797',
    // собаки
    [YORKSHIRE_TERRIER_ENG]: '99371798',
    [CORGI_ENG]: '99371799',
    [LABRADOR_RETRIEVER_ENG]: '99371800',
    [PUG_ENG]: '99371801',
    [GERMAN_SHEPHERD_ENG]: '99371802',
    [GERMAN_SPITZ_ENG]: '99371803',
    [SIBERIAN_HUSKY_ENG]: '99371804',
    [DACHSHUND_ENG]: '99371805',
    [FRENCH_BULLDOG_ENG]: '99371806',
    [CHIHUAHUA_ENG]: '99371807',
    [RUSSKIJ_TOJ_ENG]: '125452696',
};
const types = ['click', 'display'];
interface CounterConfig {
    rbmail: {
        type: string;
        id: string;
    };
    [key: string]: any;
}
interface Counters {
    [key: string]: CounterConfig;
}
export const breedsWidget: IParamsCountersName = Object.keys(breedCounters).reduce<Counters>((acc, key: keyof typeof breedCounters) => {
    types.forEach((type) => {
        const counterName = type === 'display' ? `${key}Show` : key;
        acc[counterName] = {
            rbmail: {
                type: type,
                id: breedCounters[key],
            },
        };
    });
    return acc;
}, {});
